import React from 'react';
import {observer} from 'mobx-react';
import {Store} from './stores/store';
import {classes, stylesheet} from 'typestyle';

interface ModalProps {
    modalHeader: React.ReactNode;
    modalBody: React.ReactNode;
    modalFooter?: React.ReactNode;
    onModalClose?: () => void;
    store: Store;
}

@observer
export default class Modal extends React.Component<ModalProps> {
    public componentWillMount(): void {
        this.props.store.setModalIsOpen(true);
    }

    public componentWillUnmount() {
        this.props.store.setModalIsOpen(false);
    }

    private closeModal = (): void => {
        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    };

    private renderModalFooter(): React.ReactNode | null {
        if (this.props.modalFooter) {
            return <div className="modal-footer">{this.props.modalFooter}</div>;
        }
        return null;
    }

    public render(): React.ReactNode {
        return (
            <div>
                <div className={classes('modal', modalCss.modalVisible)} tabIndex={-1} role="dialog">
                    <div className={classes('modal-dialog', modalCss.fitContent)} role="document">
                        <div className={classes('modal-content', modalCss.analyticsModalContent)}>
                            <div className={classes('modal-header', modalCss.analyticsModalHeader)}>
                                {this.props.modalHeader}
                                <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">{this.props.modalBody}</div>
                            {this.renderModalFooter()}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" />
            </div>
        );
    }
}

const modalCss = stylesheet({
    analyticsModalContent: {
        borderRadius: 2,
    },
    analyticsModalHeader: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%',
    },
    modalVisible: {
        display: 'block',
        overflowY: 'auto',
        opacity: 1,
    },
    fitContent: {
        width: 'fit-content',
        maxWidth: 'none',
    },
});



// WEBPACK FOOTER //
// ./src/Modal.tsx